import { Dropdown } from 'antd';
// eslint-disable-next-line no-use-before-define
import React from 'react';
import classNames from 'classnames';
import styles from './index.less';


  
const HeaderDropdown = ({ overlayClassName: cls, ...restProps }) => (
  
  <Dropdown
    placement="bottomCenter"
    overlayClassName={'ut-overlay-dropdown'}
    {...restProps}
  />
);

export default HeaderDropdown;
